import React from 'react';

function AdminPage() {
  const tokenPayload = JSON.parse(atob(sessionStorage.getItem('idToken').split('.')[1])); // ou localStorage

  return (
    <div style={{ padding: '40px', fontFamily: 'Arial' }}>
      <h1>Admin Panel</h1>

      <div style={{ marginTop: '20px', padding: '20px', border: '1px solid #ccc' }}>
        <h3>User Info</h3>
        <p><strong>Username:</strong> {tokenPayload['cognito:username']}</p>
        <p><strong>Email:</strong> {tokenPayload.email}</p>
        <p><strong>Group(s):</strong> {tokenPayload['cognito:groups'] ? tokenPayload['cognito:groups'].join(', ') : 'Aucun groupe détecté'}</p>
      </div>
    </div>
  );
}

export default AdminPage;
